<template>
    <div class="chat-header">
        <div class="chat-header__avatar">
            <nw-icon icon="robot-outline" />
        </div>
        <div class="chat-header__text">
            <span class="chat-header__title">{{ t('chat.header.title') }}</span>
            <span class="chat-header__subtitle">{{ t('chat.header.subtitle') }}</span>
        </div>
    </div>
    <nw-divider class="ma-0" />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

defineOptions({
    name: 'ChatHeader',
});

const { t } = useI18n();
</script>
